import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import MyNavbar from '../../../components/Customer/Mynavbar/MyNavbar';
import CategoryCircles from '../../../components/Customer/CategoryCircles/CategoryCircles';
import ProductCard from '../../../components/Customer/ProductCard/ProductCard';
import Footer from '../../../components/Customer/Footer/Footer';
import AppContext from '../../../context/AppContext';
import '../../../assests/css/customer/Kids/Kids.css';
import '../../../assests/css/customer/Home/Home.css';
import { Spinner } from 'react-bootstrap';

const KidsPage = () => {
  const navigate = useNavigate();

  const { baseUrl, selectedCategory } = useContext(AppContext);

  const [wishlist, setWishlist] = useState([]);
  const [cart, setCart] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadAllProductsWithCategory = (category_id, subCat_id) => {
    if (!category_id || !subCat_id) return;

    setAllProducts([]);
    setLoading(true);

    const formData = new FormData();
    formData.append("category_id", category_id);
    formData.append("subcategory_id", subCat_id);

    axios
      .post(
        `${baseUrl}/customer/products/loadAllProductForCustomer`,
        formData
      )
      .then((res) => {
        setAllProducts(res.data.products || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Products loading error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!selectedCategory?.id || !selectedCategory?.subcategories?.length) {
      setAllProducts([]);
      return;
    }

    const firstSubcategory = selectedCategory.subcategories[0];

    if (!firstSubcategory?.id) {
      setAllProducts([]);
      return;
    }

    loadAllProductsWithCategory(selectedCategory.id, firstSubcategory.id);
  }, [selectedCategory, baseUrl]);

  const toggleWishlist = (id) =>
    setWishlist((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );

  const toggleCart = (id) =>
    setCart((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );

  const formatProduct = (product) => {
    const categoryName = (selectedCategory?.category_name || '').toLowerCase();
    const subTitle = (product.subcategory?.title || '')
      .toLowerCase()
      .replace(/[^a-z]/g, '');

    let type = 'stitched';

    if (categoryName === 'accessories' || subTitle.includes('accessor')) {
      type = 'accessories';
    } else if (subTitle.includes('unstit') || subTitle.includes('unstich')) {
      type = 'unstitched';
    }

    return {
      ...product,
      images: product.images || [],
      price: product.base_price,
      type,
    };
  };

  const groupedBySub = {};
  (selectedCategory?.subcategories || []).forEach((sub) => {
    groupedBySub[sub.id] = {
      title: sub.title,
      products: allProducts.filter(
        (p) =>
          p.mlsubcategory_id === sub.id || p.subcategory?.id === sub.id
      ),
    };
  });

  return (
    <div>
      <MyNavbar />
      <br />

      <CategoryCircles
        loadAllProductsWithCategory={loadAllProductsWithCategory}
      />

      <section className="home-products-section">
        <div className="home-products-container">
          <h2 className="home-products-title">
            {selectedCategory?.category_name}
          </h2>

          {loading && (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <Spinner size="32" />
            </div>
          )}

          <div className="home-products-grid">
            {allProducts.map((product) => {
              const formattedProduct = formatProduct(product);

              return (
                <ProductCard
                  key={product.id}
                  product={formattedProduct}
                  type={formattedProduct.type}
                  wishlist={wishlist}
                  toggleWishlist={toggleWishlist}
                  cart={cart}
                  toggleCart={toggleCart}
                  onCardClick={() =>
                    navigate(`/product-detail/${product.id}`)
                  }
                />
              );
            })}
          </div>

          {!loading && allProducts.length === 0 && (
            <p style={{ textAlign: 'center', color: '#999' }}>
              No products found.
            </p>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default KidsPage;
